import { render, staticRenderFns } from "./LessonDetailsSection.vue?vue&type=template&id=faaddd3e&scoped=true&"
import script from "./LessonDetailsSection.vue?vue&type=script&lang=js&"
export * from "./LessonDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./LessonDetailsSection.vue?vue&type=style&index=0&id=faaddd3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaddd3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
